/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDto } from '../../models/file-dto';

export interface StorageControllerUploadFilesV1$Params {
      body: {
'files'?: Array<Blob>;
}
}

export function storageControllerUploadFilesV1(http: HttpClient, rootUrl: string, params: StorageControllerUploadFilesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileDto>>> {
  const rb = new RequestBuilder(rootUrl, storageControllerUploadFilesV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FileDto>>;
    })
  );
}

storageControllerUploadFilesV1.PATH = '/api/v1/storage';
